import { useState, useEffect } from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import { showDetailsBox, editBoxApi } from "../../../services/leitnerApi";
import { checkResponseData, customToastify, checkErrorMessage } from "../../utils/utils";
import { Link } from "react-router-dom";
import { Typography, Button, Divider } from "@mui/material";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import BoxContents from "./BoxContents";
import EditBox from "./EditBox/EditBox";
import { toast } from "react-toastify";

export default function OneBoxDetails(props) {
  const {
    oneBox,
    setBoxDetails,
    handleStartStudy,
    handleStudyCards,
    handleEditBox,
    boxesList,
    handleEditBoxlist,
    editBox,
  } = props;
  const [boxInfo, setBoxInfo] = useState({});
  const [boxCards, setBoxCards] = useState([]);

  const getBoxInfo = async (oneBox) => {
    try {
      let fetechedBoxInfo = {};
      let fetechedBoxCards = [];
      let remainCards = true;
      let page = 1;
      setBoxInfo("loading");
      while (remainCards) {
        const response = await showDetailsBox(
          { boxId: oneBox["boxId"] },
          { perPage: 50, page }
        );

        const res = checkResponseData(response);

        if (res["success"]) {
          remainCards = res["data"]["hasNextPage"];
          page++;
          fetechedBoxCards.push(...res["data"]["docs"]);
          fetechedBoxInfo = response["data"]["boxInfo"];
          // console.log("00000000", response["data"]["boxInfo"]);
          // setBoxesList(checkResponseData(getBoxesList)["data"]["docs"]);
        } else {
          fetechedBoxInfo = {};
          fetechedBoxCards = [];
          remainCards = false;
          customToastify(
            "error",
            "مشکلی در دریافت لیست کارتها وجود دارد",
            5000,
            "bottom-center"
          );
        }
      }
      setBoxInfo(fetechedBoxInfo);
      setBoxCards(fetechedBoxCards);
    } catch (error) {
      customToastify(
        "error",
        "مشکلی در دریافت لیست کارتها وجود دارد",
        5000,
        "bottom-center"
      );
    }
  };

  const updateInfo = async (data) => {
    const toastMsg = toast.loading("لطفا صبر کنید...")
    try {
      setBoxInfo("loading");
      const response = await editBoxApi(data)
      const res = checkResponseData(response);

      if (res["success"]) {
        toast.update(toastMsg, { render: res["message"] || "درخواست انجام شد", type: "success", isLoading: false, autoClose: 3000 });
        const newBoxList = [...boxesList];
        for (let index in newBoxList) {
          if (newBoxList[index]["_id"] == oneBox["boxId"]) {
            newBoxList[index] = { ...newBoxList[index], ...data };
          }
        }
        getBoxInfo(oneBox);
        handleEditBox(false);
        handleEditBoxlist(newBoxList);
      } else {
        toast.update(toastMsg, { render: res["message"] || "اتفاق غیر منتظره پیش آمده است", type: "info", isLoading: false, autoClose: 3000 });
      }
    } catch (error) {
      const errData = checkErrorMessage(error);
      let errMsg = errData["titles"] || errData["message"]
      toast.update(toastMsg, { render: errMsg || "مشکلی وجود دارد", type: "error", isLoading: false, autoClose: 3000 });

      // customToastify(
      //   "error",
      //   "مشکلی در دریافت لیست کارتها وجود دارد",
      //   5000,
      //   "bottom-center"
      // );
    }
  };
  useEffect(() => {
    getBoxInfo(oneBox);
  }, []);

  return (
    <>
      <CssBaseline />
      <Container maxWidth="sm">
        <Box sx={{ textAlign: "end", mt: 1 }}>
          <Button
            sx={{ p: 0.1, mx: 1, mt: 0 }}
            variant="contained"
            color="info"
            size="small"
            onClick={() => {
              setBoxDetails(false, "null");
            }}
            endIcon={<KeyboardBackspaceIcon />}
          ></Button>
        </Box>
        <Box
          sx={{
            bgcolor: (theme) => theme.palette.reverse.light,
            // height: "80vh",
            mt: 0.5,
            p: 1,
          }}
        >
          {editBox ? (
            <EditBox
              handleEditBox={handleEditBox}
              updateInfo={updateInfo}
              boxInfo={boxInfo}
            />
          ) : (
            <BoxContents
              boxCards={boxCards}
              boxInfo={boxInfo}
              handleStartStudy={handleStartStudy}
              handleStudyCards={handleStudyCards}
            />
          )}
        </Box>
      </Container>
    </>
  );
}
